<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('templates')"
      :columns="columns"
      :column_search="true"
      resource_url="/landing/template/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
  </div>

  <template-modal ref="template_modal" @success="refresh" />
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
} from "@/utils";
import TemplateModal from "./template_modal/Index.vue";

export default {
  name: "ProvidersDatatable",
  components: { GenericTable, TemplateModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("name"),
          name: "name",
          // width: "20%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            let is_default = row.is_default || false;
            let r = "";
            if (is_default)
              r = `<div class="icon has-text-success" data-tooltip="${v.$t(
                "default template"
              )}"><i class="fa fa-check"></i></div>`;

            return `${row.name} ${r}`;
          },
        },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  // v.$refs.template_modal.show_modal(e.detail.uuid);
                  v.$router.push({
                    path: `/landing/template/${e.detail.uuid}`,
                  });
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete template?"),
                    v,
                    () => {
                      del("/landing/template", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.template_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
